// frontend/src/services/inquiryService.js
import api from './api';

const API_PATH = '/inquiries';

// --- PUBLIC FUNCTIONS ---
// Submits the admission form. Supports FormData for file uploads.
export const submitInquiry = async (formData) => {
    // If formData is an instance of FormData, axios will automatically set the correct headers
    const response = await api.post(`${API_PATH}`, formData);
    return response.data;
};

// Fetch classes for public admission form
export const getPublicClasses = async () => {
    const response = await api.get(`${API_PATH}/classes`);
    return response.data;
};

// Check if admission number exists
export const checkAdmissionNo = async (admissionNo) => {
    const response = await api.get(`${API_PATH}/check-admission-no/${admissionNo}`);
    return response.data; // { exists: true/false }
};

// --- ADMIN FUNCTIONS ---
// Get all inquiries by status (uses authenticated 'api' instance)
export const getInquiriesByStatus = async (status = 'pending') => {
    const response = await api.get(`${API_PATH}?status=${status}`);
    return response.data;
};

export const getPendingInquiries = () => getInquiriesByStatus('pending');
export const getRejectedInquiries = () => getInquiriesByStatus('rejected');
export const getAcceptedInquiries = () => getInquiriesByStatus('accepted');

// Accept an inquiry
export const acceptInquiry = async (inquiryId, { classId, admissionNo }) => {
    const response = await api.post(`${API_PATH}/${inquiryId}/accept`, { classId, admissionNo });
    return response.data;
};

// Reject an inquiry
export const rejectInquiry = async (inquiryId) => {
    const response = await api.post(`${API_PATH}/${inquiryId}/reject`);
    return response.data;
};

export const getInquiryById = async (inquiryId) => {
    const response = await api.get(`${API_PATH}/${inquiryId}`);
    return response.data;
};
